import React, { useEffect, useState } from 'react';
import {
  BuscaParceiro,
  Finalizadora,
  InputSelect,
} from '~/components/NovosInputs';
import { ContainerInputDestino } from './styles';
import { useTransferenciaDePOS } from '../../contexts/TransferenciaDePOSContext';
import api from '~/services/api';
import { toast } from 'react-toastify';
import { StorageService } from '~/utils/classes/StorageService';

export const InputsDestino: React.FC = () => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
    clearErrors,
    lojaNormalized,
    disable,
    setDisablePatch,
    loja,
    setBandeiraSelecionada,
    transferindo,
    error,
    handleError,
  } = useTransferenciaDePOS();

  const store = new StorageService();
  const sidebarCollapsed = store.read('session', 'collapsed') as boolean;

  const [bandeiras, setBandeiras] = useState<
    { value: number; label: string; cod_loja: number }[]
  >([]);
  const [loading, setLoading] = useState(false);

  return (
    <ContainerInputDestino collapsed={sidebarCollapsed}>
      <div className="input-administradora">
        <BuscaParceiro
          label="Administradora *"
          placeholder="Selecione..."
          name="cod_pessoa"
          disabled={disable.administradora || loading || transferindo}
          register={register}
          isError={!!errors.cod_pessoa || error.cod_pessoa}
          control={control}
          customOptions={{
            buscarPor: { administradora: true, fornecedor: false, loja: false },
          }}
          changeSelected={async (selected: any) => {
            if (!selected || !selected?.cod_administradora) {
              toast.warning(
                'Houve um problema para selecionar a administradora, tente novamente',
              );
              setDisablePatch({ bandeira: true });
              return;
            }

            clearErrors('cod_pessoa');
            handleError(false, false);

            setValue('cod_pessoa', {
              value: selected?.value,
              label: selected?.label,
            });

            try {
              setLoading(true);

              const { data } = await api.get(
                `/transferencia-pos/bandeiras/${selected?.cod_administradora}`,
                {
                  params: { cod_loja: lojaNormalized },
                },
              );

              const opt = (data.data || []).map((bandeira: any) => ({
                value: bandeira.cod_seq_bandeira,
                label: `${bandeira.cod_seq_bandeira} - ${bandeira.des_bandeira} (LOJA: ${bandeira.cod_loja})`,
                ...bandeira,
              }));

              setDisablePatch({ bandeira: false });

              setBandeiras(opt);
            } finally {
              setLoading(false);
            }
          }}
        />
      </div>
      <div className="input-bandeira-finalizadora">
        <InputSelect
          label="Bandeira *"
          placeholder={
            disable.bandeira
              ? 'Selecione uma administradora...'
              : 'Selecione...'
          }
          name="cod_seq_bandeira"
          register={register}
          isError={!!errors.cod_seq_bandeira || error.cod_seq_bandeira}
          control={control}
          options={bandeiras}
          disabled={disable.bandeira || loading || transferindo}
          changeSelected={(selected: any) => {
            if (!selected) {
              toast.warning(
                'Não foi possível selecionar bandeira, tente novamente',
              );
              return;
            }

            const { value, label } = selected;
            setBandeiraSelecionada(selected);
            clearErrors('cod_seq_bandeira');
            handleError(false, false);
            setValue('cod_seq_bandeira', { value, label });
          }}
        />
        <Finalizadora
          name="cod_finalizadora_destino"
          label="Finalizadora"
          placeholder="Selecione..."
          loja={loja}
          register={register}
          control={control}
          isError={false}
          disabled={disable.finalizadora_destino || loading || transferindo}
          changeSelected={(selected) => {
            const { value, label, lojaId } = selected;

            setValue('cod_finalizadora_destino', { value, label });
          }}
        />
      </div>
    </ContainerInputDestino>
  );
};
